import { c as _c } from "react/compiler-runtime";
import { IcoRedo16, IcoUndo16 } from '@onefootprint/icons';
import type { AgentBuilderHistoryItem } from '@onefootprint/request-types/dashboard';
import { IconButton, Tooltip, useShortcut } from '@onefootprint/ui';
import capitalize from 'lodash/capitalize';
import translateOperation from './utils/translate-operation';
type Kind = 'undo' | 'redo';
const SHORTCUTS: Record<Kind, string[][]> = {
  undo: [['meta', 'z'], ['ctrl', 'z']],
  redo: [['meta', 'shift', 'z'], ['ctrl', 'shift', 'z']]
};
const isTextEditingTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) return false;
  return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable || !!target.closest('[contenteditable="true"]');
};
type HistoryButtonProps = {
  kind: Kind;
  item?: AgentBuilderHistoryItem;
  disabled: boolean;
  onClick: () => void;
};
const HistoryButton = t0 => {
  const $ = _c(16);
  const {
    kind,
    item,
    disabled,
    onClick
  } = t0;
  const isActionable = !!item && !disabled;
  let t1;
  if ($[0] !== item || $[1] !== kind) {
    t1 = item?.operation ? `${capitalize(kind)} "${translateOperation(item.operation)}"` : undefined;
    $[0] = item;
    $[1] = kind;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const tooltip = t1;
  const t2 = SHORTCUTS[kind];
  const t3 = !isActionable;
  let t4;
  if ($[3] !== onClick || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      keyCombos: t2,
      onShortcut: onClick,
      shouldHandleEvent: _temp,
      disabled: t3
    };
    $[3] = onClick;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useShortcut(t4);
  const t5 = !tooltip;
  const t6 = kind === "undo" ? IcoUndo16 : IcoRedo16;
  const t7 = !isActionable;
  let t8;
  if ($[7] !== kind || $[8] !== onClick || $[9] !== t6 || $[10] !== t7) {
    t8 = <IconButton icon={t6} size="compact" onClick={onClick} disabled={t7} aria-label={kind} />;
    $[7] = kind;
    $[8] = onClick;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t8 || $[14] !== tooltip) {
    t9 = <Tooltip key={tooltip} disabled={t5} content={tooltip}>{t8}</Tooltip>;
    $[12] = t5;
    $[13] = t8;
    $[14] = tooltip;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
export default HistoryButton;
function _temp(event) {
  return !isTextEditingTarget(event.target);
}